<template>
  <v-app class="survey-container">
    <!-- Top Banner -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="top-gray">
          <div class="left">
            <img
              src="../assets/nsf-logo.png"
              width="360"
              alt="National Science Foundation. Where Discoveries Begin"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>

    <!--Header -->
    <v-layout wrap class="no-grow">
      <v-flex xs12>
        <div class="blue-bar ml-5 px-4 py-1">
          <h1>Welcome to the U.S. National Science Foundation Survey of Federal Funds for Research and Development</h1>
        </div>
      </v-flex>
    </v-layout>

    <!-- Main Contents: Forgot Password -->
    <v-layout wrap class="page-body bg-light-blue ml-5 px-4 py-1">
      <v-flex xs4 class="flex-vert-ctr" justify-center>
        <div class="sign-in-box">
          <v-form>
            <v-layout wrap>
              <v-flex xs12>
                <h2><u>Forgot password</u></h2>
                <h3>Enter User ID to reset your password</h3>
                <div v-if="error" style="color:red;">User ID may not exist, or server error : {{ errormessage }}</div>
                <div v-if="emailed" style="color:green;">After submitting your user ID, you should receive an e-mail in a few minutes.</div>
              </v-flex>
              <v-flex class="logo-center" xs4>
                <img src="../assets/NSF_Logo_flat.png" alt="NSF logo" width="100px" />
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  solo
                  class="log-in-fields"
                  placeholder="User ID"
                  v-model="UserNameOrEmail"
                />
                <v-layout>
                  <v-flex>
                    <v-btn
                      normal
                      :loading="isLoading"
                      :disabled="!UserNameOrEmail"
                      class="blue-button"
                      @click="forgotPassword"
                    >Submit</v-btn>
                    <v-btn normal :loading="isLoading" class="blue-button" @click="cancel">Cancel</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
				<div class="content">
					<!--<p><span class="col-orange">
					<b>Warning:</b> Currently, there is an issue with the e-mail system. Please check with the system support, We apologize for the inconvenience and thank you for your cooperation.
				</span></p>-->
      </div>
      </v-flex>
    </v-layout>
    <Footer></Footer>
  </v-app>
</template>

<script>
import { authService } from "@/services/authService.js";
import router from "@/router";
import { footer } from "@/components/Footer.vue";

export default {
  name: "forgotpassword",
  data() {
    return {
      username: "",
      UserNameOrEmail: null,
      isLoading: false,
      show: false,
      error: false,
      emailed: false,
			errormessage: ""
    };
  },
  methods: {
    forgotPassword() {
      debugger;
      this.$data.isLoading = true;
      let me = this;
      //const claims = authTokenService.getClaims();
      authService
        .forgotPassword(this.$data.UserNameOrEmail)
        .then(function(response) {
          me.$data.isLoading = false;
          // Redirect to home. Look at how to redirect to nextUrl?
          me.$data.emailed = true;
          me.$data.error = false;
        })
        .catch(function(response) {
					debugger;
          console.log("Test handle error in component");
          me.$data.isLoading = false;
          me.$data.error = true;
          me.$data.emailed = false;
					me.$data.errormessage = response.response.data;
        });
    },
    cancel() {
      router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.col-orange {
  color: #c1560e;
  font-weight: bold;
}
.center {
  text-align: center;
}
.login-container {
  border-radius: 5px;
  background-color: white;
  border: 1px solid #13314f;
}

.main-title {
  color: #313b52;
  font-family: Georgia, Times New Roman, Times, serif;
  font-size: 25px;
}
.sign-in-title-outer {
  padding-top: 60px;
}
.top-title-left-border {
  border-left: 1px solid #969696;
}
.sign-in-sub-title {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 21px;
  line-height: 40px;
  font-weight: bold;
  margin: 0 0 11px 0;
}
.sign-in-sub-title-right {
  font-family: Georgia, Time New Roman, Times, Serif;
  color: #313b52;
  font-size: 40px;
  line-height: 59px;
  margin: 0 0 11px 0;
}
.content-space {
  padding: 49px 23px;
  font-family: Arial, Helvetica, san-serif;
  font-size: 1em;
  line-height: 1.8125em;
  color: #5b5853;
}
.left {
  text-align: left;
  margin-left: 2%;
}
h1 {
  margin: 10px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-family: Calibri, Georgia, Time New Roman, Times, Serif;
  color: white;
  font-size: 30px;
  line-height: 40px;
  font-weight: normal;
  margin: 0 0 11px 0;
}
.contents-pane {
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: -5%;
  background-color: #f2f7fa;
  padding: 3%;
  text-align: left;
  border-style: solid;
  border-width: 0px 0px 0px 15px;
  border-color: #365f8d;
  font-size: 11pt;
  color: black;
}
.logo-center {
  margin-top: 0%;
  margin-right: 0%;
  text-align: center;
}
.log-in-fields {
  margin-bottom: -15px;
  width: 275px;
}
.log-in-fields >>> input {
  text-align: left;
}
.indent {
  margin-left: 3%;
}

.nyi {
  display: inline-block;
  margin-top: 8px;
}

</style>
